module.exports = __webpack_public_path__ + "img/img13.88e88657.svg";